export default "__VITE_ASSET__Cj5LU$5B__"